// Phase C: bounded paid-feed pagination for the customer List view. The feed
// loads a subscription's articles newest-first in fixed-size chunks (infinite
// scroll) rather than fetching the whole set. These pure helpers keep the
// chunk size, the "is there more" rule, the chunk-merge, and the scroll trigger
// out of the component so they can be unit-tested.

// Newest-first chunk size for the infinite-scroll feed (tuning target ~20–30).
export const ARTICLE_FEED_CHUNK_SIZE = 20;

// How far (px) from the bottom of the scroll container to prefetch the next chunk.
// This is a runway: at scroll speed v (px/s) it buys ~threshold/v seconds before the user
// reaches the bottom, and the chunk fetch takes ~1s — so the threshold must exceed the
// scroll speed we want to cover. ~1500 hides the load for normal-to-brisk scrolling; an
// instant scrollbar-drag to the bottom outruns any prefetch and will still show the spinner.
export const SCROLL_LOAD_THRESHOLD_PX = 1500;

// Append a freshly fetched chunk to the loaded ones, dropping any article
// already present so an offset overlap never renders (or keys) a row twice.
// Coalesce null/undefined (a mid-session auth-null can pass an explicit null,
// which a default param wouldn't catch) so the merge never throws.
export const mergeArticleChunks = (loaded, incoming) => {
  const loadedRows = loaded || [];
  const incomingRows = incoming || [];
  const seen = new Set(loadedRows.map(article => article.id));
  return loadedRows.concat(incomingRows.filter(article => !seen.has(article.id)));
};

// True once the scroll position is within `threshold` px of the bottom.
export const isNearListBottom = ({ scrollTop, scrollHeight, clientHeight }, threshold = SCROLL_LOAD_THRESHOLD_PX) =>
  scrollHeight - scrollTop - clientHeight <= threshold;
